import { Flame, TrendingUp, FlameKindling, Wind, Wrench, Gauge } from "lucide-react";
import { Chapter, Reveal } from "./shared";
import { useSiteConfig } from "@/context/SiteConfigContext";

const SIGNS = [
  { icon: Flame, title: "Cheiro de gás", desc: "O cheiro forte é o principal sinal de alerta." },
  { icon: TrendingUp, title: "Conta de gás aumentando", desc: "Pode existir vazamento invisível na tubulação." },
  { icon: FlameKindling, title: "Chama amarelada", desc: "Indica combustão inadequada e risco." },
  { icon: Wind, title: "Chiados ou assobios", desc: "Pode indicar escape de gás na instalação." },
  { icon: Wrench, title: "Tubulação antiga ou enferrujada", desc: "Aumenta o risco de vazamentos e acidentes." },
  { icon: Gauge, title: "Perda de pressão", desc: "Seu equipamento não está funcionando bem?" },
];

export const Signs = () => {
  const cfg = useSiteConfig();
  const signs = cfg.signs?.length ? cfg.signs : SIGNS;

  return (
  <section className="bg-white py-24 sm:py-32" data-testid="signs-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Chapter num="01 — Sinais de alerta" title="Seu sistema de gás está apresentando" accent="algum destes sinais?" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        {signs.map((s, i) => {
          const IconCmp = SIGNS[i % SIGNS.length].icon;
          return (
          <Reveal key={i} delay={i * 0.08}>
            <div
              data-testid={`sign-card-${i}`}
              className="group h-full rounded-2xl border border-zinc-200 bg-white p-6 text-center transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[var(--primary)] hover:shadow-[0_18px_40px_-16px_rgba(255,184,0,0.35)]"
            >
              <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--primary)]/10 transition-colors duration-300 group-hover:bg-[var(--primary)]/20">
                <IconCmp size={26} className="text-[#E8A200]" />
              </span>
              <h3 className="font-display text-lg font-bold uppercase leading-tight text-zinc-900">{s.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-zinc-500">{s.desc}</p>
            </div>
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
